import { useEffect } from 'react';

const SCRIPT_SRC = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
const SCRIPT_ID = 'elevenlabs-convai-script';
const AGENT_ID = 'agent_8701krwsva8meycsc2yrq85nb637';

/**
 * Help assistant (ElevenLabs ConvAI widget) — toggled on/off from
 * the TopNavBar switch. While ON, the widget renders as a fullscreen
 * overlay (this is hard-coded in the widget). While OFF, it is fully
 * unmounted so the rest of the app stays interactive.
 *
 * No internal close UI — the TopNavBar toggle is the single source of
 * truth for visibility (toggling it OFF also closes the widget).
 * Escape key also flips it to OFF.
 */
const HelpAgentWidget = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;
    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      script.type = 'text/javascript';
      document.body.appendChild(script);
    }
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="help-agent-anchor" data-testid="help-agent-anchor" aria-label="Asistente de ayuda">
      <elevenlabs-convai agent-id={AGENT_ID} />
    </div>
  );
};

export default HelpAgentWidget;
